import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-cell-container',
  templateUrl: './cell-container.component.html',
  styleUrls: ['./cell-container.component.scss']
})
export class CellContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
